import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const TENANT_KEY = "prc_active_tenant_id";

export function getActiveTenantId() {
  return localStorage.getItem(TENANT_KEY) || "";
}

export function setActiveTenantId(id) {
  if (id) localStorage.setItem(TENANT_KEY, id);
  else localStorage.removeItem(TENANT_KEY);
}

api.interceptors.request.use((config) => {
  const tid = getActiveTenantId();
  if (tid) config.headers["X-Tenant-Id"] = tid;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "エラーが発生しました。もう一度お試しください。";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
